import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AiOutlineUnorderedList, AiOutlineUser} from 'react-icons/ai';
import {Popover, Button} from 'antd';
import {closeCurrentScreen, openScreen, sidebarToggle} from '../../actions/uiActions';
import {startLogout} from '../../actions/auth';
import {useHistory} from 'react-router-dom';

import handdoHLogo from '../../resources/logos/handdoLogoNew2.png';
import handdoHLogoL from '../../resources/logos/handdoLogoNew.png';

const SCREEN_OPTIONS = [
    {value: 'uiOpenDashboard', label: 'Inicio'},
    {value: 'uiOpenListDevice', label: 'Dispositivos'},
    {value: 'uiOpenListUser', label: 'Usuarios'},
    {value: 'uiOpenListDelivery', label: 'Deliverys'},
    {value: 'uiOpenListCustomer', label: 'Clientes'},
    {value: 'uiOpenListDocument', label: 'Documentos'},
    {value: 'uiOpenListPaymentMethod', label: 'Métodos de Pago'},
    {value: 'uiOpenListProduct', label: 'Productos'},
    {value: 'uiOpenListTax', label: 'Impuestos'},
    {value: 'uiOpenListMeasurementUnit', label: 'Unidades de medidas'},
    {value: 'uiOpenListWarehouse', label: 'Almacenes'},
    {value: 'uiOpenListProductHandlers', label: 'Manejadores de Producto'},
];

export const Navbar = () => {
    const dispatch = useDispatch();
    const sidebar = useSelector(state => state.ui.sidebar);
    const username = useSelector(state => state.auth.username);
    const businessName = useSelector(state => state.auth.businessName);

    const history = useHistory(); // v5

    const [selectValue, setSelectValue] = useState('DEFAULT');

    const handleSidebarToggle = () => dispatch(sidebarToggle(!sidebar));

    const handleLogout = async () => {
        await dispatch(startLogout());
        history.push('/login'); // v5
    };

    const handleOpenScreen = (e) => {
        const value = e.target.value;
        if (value === 'DEFAULT') return;

        dispatch(closeCurrentScreen());
        dispatch(openScreen(value));

        // Resetea el select
        setSelectValue('DEFAULT');
    };

    return (
        <nav
            className="sticky top-0 z-50 bg-white shadow flex items-center justify-between flex-wrap px-5 h-[60px] w-full">
            <div className="flex items-center gap-4">
                <img
                    className={sidebar ? 'w-10 h-10 object-scale-down' : 'w-[124px] h-[45px] object-cover'}
                    src={sidebar ? handdoHLogo : handdoHLogoL}
                    alt="Handdo Logo"
                />

                <button
                    aria-label="Alternar menú lateral"
                    onClick={handleSidebarToggle}
                    className="border-none bg-inherit outline-none mr-3"
                >
                    <AiOutlineUnorderedList size={25}/>
                </button>

                <select
                    id="pageSelect"
                    value={selectValue}
                    onChange={(e) => {
                        setSelectValue(e.target.value);
                        handleOpenScreen(e);
                    }}
                    className=" h-10 w-[180px] sm:w-[220px] md:w-[260px] lg:w-[300px] bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700 px-3 outline-none"
                >
                    <option value="DEFAULT" disabled>Seleccione una pantalla...</option>
                    {SCREEN_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </div>

            <div className="flex items-center gap-4 pr-4">
                <Popover
                    placement="bottomRight"
                    trigger="click"
                    content={
                        <div className="text-sm min-w-[180px]">
                            <p className="font-medium">{username}</p>
                            <p className="text-gray-600">{businessName}</p>
                            <button
                                className="text-blue-600 hover:underline mt-2"
                                onClick={handleLogout}
                            >
                                Logout
                            </button>
                        </div>
                    }
                >
                    <Button aria-label="Menú de usuario" icon={<AiOutlineUser size={27}/>}/>
                </Popover>
            </div>
        </nav>
    );
};